<template>

  <template v-if="$props.state_slug === 'iso-reassigned' || $props.state_slug === 'manager-reassigned'">
    <IsoInReassign
      :test_work_queue_id="$route.query.test_work_queue_id"
      :test_work_queue_phase_id="$route.query.test_work_queue_phase_id"
      :internal_phase_id="$route.query.internal_phase_id"
      :prescription_test_id="$route.query.prescription_test_id"
      :state_slug="$props.state_slug"
      :prescription="$route.query.prescription" />
  </template>

  <template
    v-if="[
      'iso-failed',
      'manager-failed',
      'on-hold',
    ].includes($props.state_slug)">
    <IsoInFailed
      :test_work_queue_id="$route.query.test_work_queue_id"
      :test_work_queue_phase_id="$route.query.test_work_queue_phase_id"
      :internal_phase_id="$route.query.internal_phase_id"
      :state_slug="$props.state_slug"
      :prescription="$route.query.prescription" />
  </template>

  <template v-if="$props.state_slug === 'iso-in-changed-test' || $props.state_slug === 'manager-changed-test'">
    <IsoInChangedTest
      :test_work_queue_id="$route.query.test_work_queue_id"
      :test_work_queue_phase_id="$route.query.test_work_queue_phase_id"
      :test_id="$route.query.test_id"
      :internal_phase_id="$route.query.internal_phase_id"
      :prescription_test_id="$route.query.prescription_test_id"
      :state_slug="$props.state_slug"
      :laboratory_list_row_id="$route.query.laboratory_list_row_id"
      :prescription="$route.query.prescription" />
  </template>
  <template v-if="($props.state_slug === 'iso-in-changed-date' || $props.state_slug === 'manager-changed-date') && clinicId">
    <IsoInChangedDate
      :test_work_queue_id="$route.query.test_work_queue_id"
      :test_work_queue_phase_id="$route.query.test_work_queue_phase_id"
      :test_id="$route.query.test_id"
      :internal_phase_id="$route.query.internal_phase_id"
      :prescription_test_id="$route.query.prescription_test_id"
      :state_slug="$props.state_slug"
      :laboratory_list_row_id="$route.query.laboratory_list_row_id"
      :prescription="$route.query.prescription"
      :delivery_date="$route.query.delivery_date"
      :clinic_id="clinicId"/>
  </template>

  <template v-if="$props.state_slug === 'iso-in-choose-fork'">
    <IsoInChangeFork
      :test_work_queue_id="$route.query.test_work_queue_id"
      :test_work_queue_phase_id="$route.query.test_work_queue_phase_id"
      :internal_phase_id="$route.query.internal_phase_id"
      :prescription_test_id="$route.query.prescription_test_id"
      :test_id="$route.query.test_id"
      :state_slug="$props.state_slug"
      :prescription="$route.query.prescription" />
  </template>

  <template v-if="$props.state_slug === 'iso-custom' || $props.state_slug === 'manager-custom'">
    <CustomFlow
      :test-work-queue-phase-id="parseInt($route.query.test_work_queue_phase_id)"
      :test-work-queue-id="parseInt($route.query.test_work_queue_id)"
      :prescription-id="parseInt($route.query.prescription_id)"
      :prescription="$route.query.prescription"
      :internal-state="$props.state_slug"
      :phase-state="phaseStateSlug" />
  </template>

</template>

<script>
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import { fetchById as fetchTestWorkQueuePhaseById } from '@/use/repositories/testWorkQueuePhase/fetchById';
import { fetchById as fetchPrescriptionById } from '@/use/repositories/prescriptions/fetchById';

import IsoInReassign from "./IsoInReassign";
import IsoInFailed from "./IsoInFailed";
import IsoInChangedTest from "./IsoInChangedTest";
import IsoInChangeFork from "./IsoInChangeFork";
import CustomFlow from "@/components/Iso-in/CustomFlow";
import IsoInChangedDate from "./IsoInChangedDate.vue";

export default {
  name: "IsoInState",
  props: ['state_slug', 'phase_state_slug'],
  components: {
    IsoInReassign,
    IsoInFailed,
    IsoInChangedTest,
    IsoInChangeFork,
    CustomFlow,
    IsoInChangedDate
},
  setup(props) {
    const route = useRoute();
    const clinicId = ref(null);
    const phaseStateSlug = ref(props.phase_state_slug || route.query.phase_state_slug || route.query.test_work_queue_phase_state_slug || null);

    console.log("STATE SLUG: " + props.state_slug);
    console.log("TEST WORK QUEUE PHASE ID: " + route.query.test_work_queue_phase_id);
    console.log("INTERNAL PHASE ID: " + route.query.internal_phase_id);
    console.log("LABORATORY LIST ROW ID: " + route.query.laboratory_list_row_id);

    onMounted(async () => {
      if (route.query.prescription_id) {
        try {
          const response = await fetchPrescriptionById(route.query.prescription_id, 'with_basic_data', false);
          clinicId.value = response.prescription?.clinic?.id;
        } catch (error) {
          console.error('Error fetching prescription:', error);
        }
      }

      if (!phaseStateSlug.value && route.query.test_work_queue_phase_id) {
        try {
          const response = await fetchTestWorkQueuePhaseById(route.query.test_work_queue_phase_id, 'with_iso_details');
          phaseStateSlug.value = response.testWorkQueuePhase.state.slug;
        } catch (error) {
          console.error('Error fetching phase state:', error);
        }
      }
    });

    return {
      clinicId,
      phaseStateSlug,
    };
  }
}
</script>
